import React from "react";
import { ForgotPassword } from "@grassrootly/api";
import useBaseRequest from "../../api/BaseRequest";
import { useNavigation } from "@react-navigation/native";
import { useAlert } from "@grassrootly/rn-core";

export function useForgotPassword() {
  const navigation = useNavigation();
  const { danger, success } = useAlert();

  const { loading: reseting, execute: forgotPassword } = useBaseRequest(ForgotPassword, {
    onCompleted: (data) => {
      if (!data) {
        danger({ message: "Something went wrong, please try again." });
        return;
      }
      success({ message: "Reset password link sent to your email. Check your inbox." });
    },
  });

  const onSubmit = ({ email }: { email: string }) => {
    forgotPassword({ email });
  };

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    navigation.navigate("login");
  };

  return { onSubmit, reseting, goBack };
}
